module.exports = __webpack_public_path__ + "static/docs/Vermietungsplaene_Tuefwis_Keller_Haus_D_200115.d2a0c6e0.pdf";